import CategoryStep from '@/features/membership/application/components/category-step'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/membership/apply/category',
)({
  component: CategoryStep,
})
